<div class="modal-content" piqetAngularDraggable>
  <ng-container
    *ngrxLet="{
      wasteScenarioprocess: (customFacade.wasteScenarioProcessList$ | async)
    } as customWasteScenarioData"
  >
    <div class="modal-header">
      <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
      </h2>

      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal">
      <div class="bootstrap-dialog-body">
        <div class="bootstrap-dialog-message">
          <form
            id="frmProjectCreate"
            [formGroup]="customWasteScenarioForm"
            [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
          >
            <div id="WasteScenarioValidationSummary" class="field-validation-error"></div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group required">
                  <piqet-angular-common-input
                    formControlName="wasteScenarioName"
                    [control]="customWasteScenarioForm.get('wasteScenarioName')"
                    label="Waste scenario name"
                    placeholder="Waste scenario name"
                    [maxLength]="50"
                    [submitted]="submitted"
                  >
                  </piqet-angular-common-input>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group required">
                  <label class="sub-header-drpdown">Location</label>
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="locationList"
                    [searchable]="false"
                    formControlName="location"
                    bindLabel="name"
                    class="locationList"
                    [searchFn]="commonInputSearch"
                    bindValue="id"
                    (change)="getDefaultvalue()"
                    placeholder="Location *"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      (submitted || customWasteScenarioForm.controls['location']?.touched) &&
                      (customWasteScenarioForm.controls['location']?.invalid ||
                        customWasteScenarioForm.controls['location'].value?.description ===
                          'Material')
                    "
                    class="input-error"
                  >
                    Location is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" *ngIf="isHideDropDown">
                <div class="form-group required">
                  <label
                    *ngIf="customWasteScenarioForm.get('organizationName')?.value"
                    class="sub-header-drpdown pb-2"
                    >Organization</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #material
                    [items]="organizationlist"
                    [searchable]="false"
                    bindLabel="name"
                    formControlName="organizationName"
                    [searchFn]="commonInputSearch"
                    [readonly]="isDisabledDropDown"
                    placeholder="Organization"
                    [(ngModel)]="setOrganizationValue"
                    (change)="selectValue($event)"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          (input)="material.filter($any($event.target).value)"
                          class="accordion-search form-control search-input"
                          id="inputValidation"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      (customWasteScenarioForm.controls['organizationName']?.touched &&
                        customWasteScenarioForm.controls['organizationName']?.invalid) ||
                      customWasteScenarioForm.controls['organizationName'].value?.name ===
                        ' Organization' ||
                      (submitted &&
                        !customWasteScenarioForm.controls['organizationName'].value?.name)
                    "
                    class="input-error"
                  >
                    Organization is required.
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngrxLet="customFacade.customWasteScenarioError$ as error">
              <span class="input-error">{{ error }}</span>
            </ng-container>
            <span *ngIf="mustGreaterValue" class="requiredPer"
              >The total percentage must be 100%</span
            >
            <div class="row" formGroupName="wasteScenarioProcessForm">
              <div class="col-sm-2">
                <div class="form-group required">
                  <label class="sub-header-drpdown">Material</label>
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #material
                    container="body"
                    [virtualScroll]="true"
                    class="energyMaterial"
                    [items]="energyItems"
                    [searchable]="false"
                    bindLabel="description"
                    [searchFn]="commonInputSearchForMaterial"
                    groupBy="childItems"
                    (change)="getDefaultvalue()"
                    formControlName="material"
                    placeholder="Material *"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="accordion-search form-control search-input"
                          id="inputValidation"
                          (input)="material.filter($any($event.target).value)"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>

                    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" [title]="item.description" class="truncate">
                        {{ item.description }}
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" [title]="item.description" class="truncate">
                        {{ item.description }}
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span
                        class="ng-value-label truncate"
                        [title]="item.description"
                        placement="bottom"
                        >{{ item.description }}</span
                      >
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span
                        class="ng-option-label truncate"
                        [title]="item.description"
                        placement="bottom"
                        >{{ item.description }}</span
                      >
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      processSubmitted &&
                      customWasteScenarioForm.get('wasteScenarioProcessForm')?.get('material')
                        ?.errors
                    "
                    class="input-error"
                  >
                    <div
                      *ngIf="((processSubmitted || customWasteScenarioForm.get('wasteScenarioProcessForm')?.get('material')?.touched) && customWasteScenarioForm.get('wasteScenarioProcessForm')?.get('material')?.errors?.['required'])"
                    >
                      Please select material
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngFor="let identifier of endOfLifeIdentifiers; let i = index">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label class="labelColor">{{ identifier.name }}</label>
                    <div class="services-form wasteScenarioInput">
                      <input
                        [formControlName]="'eol_' + identifier.id"
                        maxlength="5"
                        type="text"
                        (keypress)="numberOnly($event)"
                        (blur)="checkGreaterValueMustGreaterValue()"
                        [placeholder]="identifier?.name"
                        (paste)="validatePaste($event)"
                        (input)="checkGreaterValueMustGreaterValue()"
                      />
                      <div
                        *ngIf="
                          processSubmitted &&
                          wasteScenarioProcessForm.get('eol_' + identifier.id)?.errors
                        "
                        class="input-error"
                      >
                        <div
                          *ngIf="wasteScenarioProcessForm.get('eol_' + identifier.id)?.errors?.['required']"
                        >
                          Please enter {{ identifier.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="col-sm-4 d-flex align-items-center">
                <div
                  style="margin-bottom: 40px"
                  *ngrxLet="customFacade.wasteGridData$ as wasteGridData"
                >
                  <ng-container
                    *ngrxLet="customFacade.isProcessEditWasteScenario$ as isIngredirentEdit"
                  >
                    <button
                      *ngIf="!isIngredirentEdit"
                      class="blue-hoki-add"
                      type="button "
                      id="btnmanufacturingprocessofmaterial "
                      (click)="addWasteScanarioProcess(wasteGridData)"
                      (mouseenter)="changeImageOnHover(true)"
                      (mouseleave)="changeImageOnHover(false)"
                    >
                      <img
                        class="fa fa-plus"
                        width="48"
                        height="45"
                        [src]="
                          isHovered
                            ? './assets/icons/add-record-hover.svg'
                            : './assets/icons/add-record.svg'
                        "
                      />
                    </button>
                    <button
                      *ngIf="isIngredirentEdit"
                      class="blue-hoki"
                      type="button "
                      title="Update "
                      id="btnUpdateIngrediant"
                      name="btnUpdateIngrediant "
                      (click)="editWasteScanarioProcess(wasteGridData)"
                    >
                      <i class="fa fa-refresh"></i>
                    </button>
                  </ng-container>
                </div>
                <ng-container *ngrxLet="customFacade.wasteGridData$ as wasteGridData">
                  <div
                    *ngIf="
                      this.wasteScenarioProcessForm.controls['material'].value &&
                      wasteGridData.length == 0
                    "
                    class="redErrorTag settMarginWaste"
                  >
                    <span>Atleast one record is requried.</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </form>
          <div id="divmanufactureofmaterialList " class="grid-div">
            <ng-container *ngrxLet="customFacade.wasteGridData$ as wasteGridData">
              <piqet-angular-portlet
                *ngIf="gridLoaded.value"
                [columnDefs]="processColumnDef"
                [frameworkComponents]="frameworkComponents"
                [gridData]="wasteGridData"
                [hideSearch]="true"
                [hidePagination]="true"
                [createAccess]="checkEntireAccess"
                [class]="'wasteScenarioClass wasteGridHeight overflowCheck'"
                [isInlineGrid]="true"
              >
              </piqet-angular-portlet>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="modal-footer customBtn-margin-top">
        <ng-container *ngrxLet="customFacade.wasteScenarioProcessList$ as wasteScenarioProcessList">
          <button type="button " class="cancelBtn" (click)="onClose()">Cancel</button>
          <button
            type="button "
            class="modelBtn purpleBtnHoverEffect"
            *ngIf="checkEntireAccess"
            (click)="onSave(wasteScenarioProcessList)"
          >
            Save
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
